<template>
  <app-modal name="report-statistics-modal" hide-title :title="title" @before-open="beforeOpen"  hide-footer @before-close="beforeClose" @on-ok="onOk">
    <report-statistics :directories="directories" :tag="tag"></report-statistics>
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
// import ReportStatistics from '@/portal-components/report/report-statistics';

export default {
  name: 'ReportStatisticsModal',
  components: {
    AppModal,
  },
  data() {
    return {
      title: '',
      directories: [],
      tag: '',
    };
  },
  computed: {},
  methods: {
    beforeClose() {
    },
    onOk() {
    },
    beforeOpen(params) {
      this.directories = params.model.selectedDirectories;
      this.tag = params.model.tag;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/report/report-statistics-modal.vue